import { render, staticRenderFns } from "./CaptainsStatusesTimeline.vue?vue&type=template&id=252874f6"
import script from "./CaptainsStatusesTimeline.vue?vue&type=script&lang=js"
export * from "./CaptainsStatusesTimeline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports